import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';
import type FluidLinkViewStore from './schema/FluidLinkViewStore';

const fluidLinkViewStore: FluidLinkViewStore = {
    linkViewStates: new ObservableMap({}),
    isDiscoverManifestLoaded: false,
    viewStatesWithLoopFocus: [],
};

export const getStore = createStore<FluidLinkViewStore>('fluidLinkViewStore', fluidLinkViewStore);
export default getStore;
